import { render, staticRenderFns } from "./ShipmentTable.vue?vue&type=template&id=259ec1fe&scoped=true"
var script = {}
import style0 from "./ShipmentTable.vue?vue&type=style&index=0&id=259ec1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259ec1fe",
  null
  
)

export default component.exports